import React, { useState } from 'react';
import { RModal } from 'recruit/components';
import LogoBar from './LogoBar';
import { CandidateLoginForm } from './CandidateLoginForm';
import { CandidateCreateAccountForm } from './CandidateCreateAccountForm';
import { CandidateVerifyForm } from './CandidateVerifyForm';
import { CandidateSetPasswordForm } from './CandidateSetPasswordForm';

export type CandidateAuthMode = 'login' | 'create-account' | 'verify' | 'set-password';

interface CandidateAuthDialogProps {
    initialMode: CandidateAuthMode;
    onClose: () => void;
    onSuccess?: () => void;
}

export function CandidateAuthDialog({ initialMode, onClose, onSuccess }: CandidateAuthDialogProps) {
    const [mode, setMode] = useState<CandidateAuthMode>(initialMode);

    function handleSuccess() {
        onSuccess?.();
        onClose();
    }

    if (mode === 'login') {
        return (
            <RModal title="Log In" onClose={onClose} headerBar={<LogoBar />}>
                <CandidateLoginForm
                    onSuccess={handleSuccess}
                    onSwitchToCreateAccount={() => setMode('create-account')}
                />
            </RModal>
        );
    }

    if (mode === 'create-account') {
        return (
            <RModal title="Create an Account" onClose={onClose} headerBar={<LogoBar />}>
                <CandidateCreateAccountForm
                    onSignupInitiated={() => setMode('verify')}
                    onSwitchToLogin={() => setMode('login')}
                />
            </RModal>
        );
    }

    if (mode === 'verify') {
        return (
            <RModal title="Verify Your Phone" onClose={onClose} headerBar={<LogoBar />}>
                <CandidateVerifyForm onVerifySuccess={() => setMode('set-password')} />
            </RModal>
        );
    }

    return (
        <RModal title="Set Your Password" onClose={onClose} headerBar={<LogoBar />}>
            <CandidateSetPasswordForm onComplete={handleSuccess} />
        </RModal>
    );
}
